/**
 * A kép nélküli avatar monogramja (Geri kérése, #117): az első KÉT SZÓ
 * kezdőbetűje, ÉKEZET NÉLKÜL. Szó = szóközzel, `_`-sal, `-`-szal vagy ponttal
 * határolt rész; a kezdőbetűje az első betűje (a szám, írásjel, emoji kimarad),
 * a csak számból álló szó kiesik: „100+ km bringások” → „KB”, „(Ó)budai
 * vagányok” → „OV”, „kata_fut” → „KF”. Egyszavas névnél egy betű („bdomi” →
 * „B”). Ha a névben nincs betű, `null`: ilyenkor a hívó ikont mutat. (A korábbi
 * `name.slice(0, 1)` „(”-t vagy számot írt ki, emojinál fél karaktert.)
 */
export function avatarInitials(name: string): string | null {
  const initials = name
    .split(/[\s_.-]+/u)
    .map((word) => /\p{L}/u.exec(word)?.[0])
    .filter((letter): letter is string => letter !== undefined)
    .slice(0, 2)
    .map((letter) => letter.normalize('NFD').replace(/\p{M}/gu, '').toLocaleUpperCase('hu'))
    .join('');
  return initials || null;
}
